import * as MC_CONST from './constants'
import lodash from 'lodash'
import { profile } from '../stores/storages/ProfileStorage'
import * as Const from './config'
import Helpers from '../lib/helpers'

const MessagesUtil = {
  messagePacketId: (type) => {
    let text = ''
    let prefix = '05' // desktop
    const subType = '000'
    switch (type) {
      case 'chat':
        prefix += '01'
        break
      case 'groupchat':
        prefix += '02'
        break
      case 'official':
        prefix += '03'
        break
      case 'room':
        prefix += '04'
        break
      case 'broadcast':
        prefix += '05'
        break
      default:
        prefix += '00'
        break
    }
    prefix += subType

    const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'

    for (let i = 0; i < 32; i++) { // eslint-disable-line
      text += possible.charAt(Math.floor(Math.random() * possible.length))
    }
    text = `${prefix}_${text}`
    return text
  },
  xmppid: () => {
    let i
    while (!i) {
      i = Math.random()
        .toString(36)
        .substring(2, 12)
    }
    return i
  },
  getMsisdnFrom: (from) => {
    if (from && from.includes('@')) {
      return from.substring(0, from.lastIndexOf('@'))
    }
    return from
  },
  getThreadId: (type, message) => {
    const { attrs, children } = message
    let thread = ''
    switch (type) {
      case MC_CONST.NODE_TYPE_MESSAGE.CHAT: {
        const threadRef = children.find(item => item.name === 'threadRef')
        if (lodash.has(threadRef, 'attrs.toref')) {
          thread = threadRef.attrs.toref;
        } else {
          thread = attrs.from;
        }
        break;
      }
      case MC_CONST.NODE_TYPE_MESSAGE.GROUPCHAT: 
      case MC_CONST.NODE_TYPE_MESSAGE.OFFICIAL: {
        thread = attrs.from;
        break
      }
      default:
        break;
    }
    return MessagesUtil.getMsisdnFrom(thread);
  },
  /**
   *
   * @param {String} type: Loại tin nhắn (chat/groupchat/official)
   * @param {String} threadId: ThreadId
   *
   * Hàm trả về topic id tương ứng. Ví dụ:
   *    Chat 1-1: threadId là 0396783058 => topicId là usr0396783058
   *    GroupChat: threadId là 0969633777_1562576287276 => topicId là grp
   * TopicId dùng để tra cứu thông tin threadChat và tin nhắn
   */
  getTopicId: (type, threadId) => {
    switch (type) {
      case MC_CONST.NODE_TYPE_MESSAGE.CHAT:
      case MC_CONST.NODE_TYPE_MESSAGE.OFFICIAL:
        return `usr${threadId}`;
      case MC_CONST.NODE_TYPE_MESSAGE.GROUPCHAT:
        return `grp${threadId}`;
      default:
        return threadId;
    }
  },
  getReplyInfo: (stanza) => {
    const { children } = stanza
    let reply = null
    if (children.find(item => item.name === 'reply')) {
      reply = children.find(item => item.name === 'reply').children[0]
    }
    if (reply) {
      try {
        reply = JSON.parse(reply)
      } catch (err) {
        reply = null
      }
    }
    return reply
  },
  getFrom: (type, message) => {
    console.log(type, message)
    switch (type) {
      case MC_CONST.NODE_TYPE_MESSAGE.CHAT:
      case MC_CONST.NODE_TYPE_MESSAGE.OFFICIAL:
        return MessagesUtil.getMsisdnFrom(message.attrs.from);
      case MC_CONST.NODE_TYPE_MESSAGE.GROUPCHAT:
        return message.attrs.member
      default: {
        break;
      }
    }
    return ''
  },
  getFromVtMessageEvent: (message) => {
    const { children } = message
    const threadOrg = children.find(item => item.name === 'threadOrg')
    if (lodash.has(threadOrg, 'attrs.to')) {
      const to = threadOrg.attrs.to;
      return MessagesUtil.getMsisdnFrom(to);
    }
    return ''
  },
  getMessageData: (type, message) => {
    const { attrs, children } = message
    const { timesend, id } = attrs
    const threadId = MessagesUtil.getThreadId(type, message);
    const topicId = MessagesUtil.getTopicId(type, threadId);
    const from = MessagesUtil.getFrom(type, message);
    const date = timesend ? new Date(Number(timesend)) : new Date()
    const bodyChild = children.find(item => item.name === 'body')
    const sbodyChild = children.find(item => item.name === 'sbody')
    const tagChild = children.find(item => item.name === 'tag')
    const tagAll = !!children.find(item => item.name === 'tag_all')
    const crypt = children.find(item => item.name === 'crypt')
    const body = bodyChild ? bodyChild.children[0] : ''
    const sbody = sbodyChild ? sbodyChild.children[0] : ''
    const tags = tagChild ? Helpers.parse(tagChild.children[0]) : []
    const reply = MessagesUtil.getReplyInfo(message)
    let offline = false
    const offlineTag = children.find(item => item.name === 'offline')
    if (offlineTag) offline = true
    const data = {
      threadId: threadId,
      content: body,
      scontent: sbody,
      id,
      from: `usr${from}`,
      topic: topicId,
      ts: date,
      attributes: message.attrs,
      tags,
      offline,
      tagAll,
      crypt,
      fromMsisdn: from,
    }
    if (reply) {
      data.reply = reply
    }
    if (from === profile.username) {
      data.delivered = MC_CONST.MESSAGE_DELIVERED.SENT
      data._status = Const.MESSAGE_STATUS_SENT
    }
    return data;
  },
  getMessageType: (message) => {
    const { attrs } = message;
    const { type, subtype } = attrs;
    return {
      type, subtype
    }
  },
  isMe: (message) => {
    const { attrs } = message
    const { type } = attrs;
    switch (type) {
      case MC_CONST.NODE_TYPE_MESSAGE.CHAT: {
        return attrs.from === profile.username;
      }
      default: {
        return false;
      }
    }
  }

}

export default MessagesUtil
